import { AxiosPromise } from 'axios';

import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';

type getDashboardHtttpResponseBody = any;

const axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

export type MsResponseData = {
  CODIGO_RESPUESTA: string;
  MENSAJE_RESPUESTA: string;
  data: any[];
};

const makeHttpRequest = (
  body: any,
  path: string
): AxiosPromise<getDashboardHtttpResponseBody> => {
  body.app = 'telemetria_orvis';
  return axios.http.post(
    `Metabase/PostgenericA/telemetria_orvis/` + path,
    body
  );
};

const makeHttpRequestNormalized = (
  service: string,
  body: any
): AxiosPromise<MsResponseData> => {
  return axios.http.post(
    `Metabase/PostgenericA/telemetria_orvis/` + service,
    body
  );
};

export const fetchTelemetria = (body: any, path: string) =>
  makeHttpRequest(body, path);
